var $cookie_notice = $('.cookie-notice');
var $js_match_height = $('.js-match-height');
var $js_match_height_by_row = $('.js-match-height-only-by-row');

/**
 * Open real3dflipbook pdf_lv in lightbox from hidden shortcode
 */
function clickCatalogue(event) {
  event.preventDefault();

  jQuery(this).closest('.card-catalogue')
    .find('.hidden-creatimreal3dflipbook-shortcode')
    .find('div[class^="real3dflipbook"]')
    .trigger('click');
}

function openReal3dFlipBook() {
  jQuery('body').on('click', 'a.js-real3dflipbook-lightbox', clickCatalogue);
  jQuery('body').on('click', 'img.js-real3dflipbook-lightbox', clickCatalogue);
  jQuery('body').on('click', '.type.js-real3dflipbook-lightbox',clickCatalogue);
}

function countCareerField() {
  jQuery.ajax({
    type: "POST",
    url: ajax_object.ajaxurl,
    async: true,
    data: {
      action: 'career_field_num_ajax'
    },
    success: function (response) {
      response = jQuery.parseJSON(response);

      for (var key in response) {
        if(response[key] > 0) {
          var identifier = '#career-' + key + ' a';
          var mobile_identifier = '#career-mobile-' + key + ' a';

          $(identifier).append('<span class="counter">' + response[key] + '</span>');
          $(mobile_identifier).append('(' + response[key] + '</span>');
        }
      }
    }
  });
}

function allowCookies() {

    var addsCookie = false;
    var funcCookie = false;
    var analyticsCookie = false;

    if (typeof Cookies.get('funcCookie') === 'undefined'){
        $cookie_notice.css('display', 'block');

        $('#cookie-allow-all').click(function () {
            Cookies.set('funcCookie', true, { expires: 365, secure: true });
            Cookies.set('addsCookie', true, { expires: 365, secure: true });
            Cookies.set('expCookie', true, { expires: 365, secure: true });

            $cookie_notice.css('display', 'none');

        });


        $('#cookie-close').click(function () {

            if ($('#adds-cookie').prop('checked')) {
                addsCookie = true;
            }

            if ($('#func-cookie').prop('checked')) {
                funcCookie = true;
            }

            if ($('#analytics-cookie').prop('checked')) {
                analyticsCookie = true;
            }

            Cookies.set('funcCookie', funcCookie, { expires: 365, secure: true });
            Cookies.set('addsCookie', addsCookie, { expires: 365, secure: true });
            Cookies.set('expCookie', analyticsCookie, { expires: 365, secure: true });

            $cookie_notice.css('display', 'none');

        });
    }

    $('.cookie-column label.custom-input-toggle').click(function () {
        var $cookie_alow_text = $(this).next('.cookie-allow-text');
        if($(this).prev('input').attr('checked') == null){
            $cookie_alow_text.text('Dovolim');

        } else {
            $cookie_alow_text.text('Ne dovolim');
        }
    });

    $('#cookie-save-changes').click(function (event) {
        // funcCookie = false;
        // addsCookie = false;
        event.preventDefault();

        $('#cookie-save-changes-spinner').show();

        if ($('#page-adds-cookie').prop('checked')) {
            addsCookie = true;
        }

        if ($('#page-func-cookie').prop('checked')) {
            funcCookie = true;
        }

        if ($('#page-analytics-cookie').prop('checked')) {
            analyticsCookie = true;
        }

        Cookies.set('funcCookie', funcCookie, { expires: 365, secure: true });
        Cookies.set('addsCookie', addsCookie, { expires: 365, secure: true });
        Cookies.set('expCookie', analyticsCookie, { expires: 365, secure: true });

        setTimeout(
          function()
          {
              $('#cookie-save-changes-spinner').hide();
          }, 1500);

        location.reload();
    });


    $('#disable-google-analytics').click(function (event) {
      event.preventDefault();
      Cookies.set('expCookie', analyticsCookie, { expires: 365, secure: true });
      location.reload();
    });


    if($('.page-cookie-notice').length > 0 || $cookie_notice.length > 0){
        var currFuncCookieval = Cookies.get('funcCookie');
        var currAddsCookieval = Cookies.get('addsCookie');
        var currAnalyticsCookieval = Cookies.get('expCookie');

        var $column_func_cookies_cookie_allow_text = $('#column-func-cookies .cookie-allow-text');
        var $column_adds_cookies_cookie_allow_text = $('#column-adds-cookies .cookie-allow-text');
        var $column_analytics_cookies_cookie_allow_text = $('#column-analytics-cookies .cookie-allow-text');


        if(currFuncCookieval === 'true') {
            $('#page-func-cookie').prop('checked', true);
            $column_func_cookies_cookie_allow_text.html('Dovolim');
        } else {
            $column_func_cookies_cookie_allow_text.html('Ne dovolim');
        }

        if(currAddsCookieval === 'true') {
            $('#page-adds-cookie').prop('checked', true);
            $column_adds_cookies_cookie_allow_text.html('Dovolim');
        } else {
            $column_adds_cookies_cookie_allow_text.html('Ne dovolim');
        }

        if(currAnalyticsCookieval === 'true') {
            $('#page-analytics-cookie').prop('checked', true);
            $column_analytics_cookies_cookie_allow_text.html('Dovolim');
        } else {
            $column_analytics_cookies_cookie_allow_text.html('Ne dovolim');
        }
    }

    //DELETE COOKIES
    if(Cookies.get('funcCookie') === 'false') {}
    if(Cookies.get('addsCookie') === 'false') {}
    if(Cookies.get('expCookie') === 'false') {
        Cookies.set('ga-disable-UA-129909851-1', 'true', { expires: 365, path: '/' });
        // Cookies.remove('_ga', { path: '/', domain: '.tus.si' });
        // Cookies.remove('_gat', { path: '/', domain: '.tus.si' });
        // Cookies.remove('_gid', { path: '/', domain: '.tus.si' });
        // Cookies.remove('_gcl_au', { path: '/', domain: '.tus.si' });
        Cookies.remove('uvc');
        Cookies.remove('act');
        Cookies.remove('_atuvc');
        Cookies.remove('_atuvs');
        Cookies.remove('_hjincludedInSample');
    } else {
        Cookies.remove('ga-disable-UA-129909851-1');
    }


}

function goBack() {
    window.history.back();
}


function vcAccordion() {
    jQuery('.tus-accordion-toggle').click(function () {
        if($(this).hasClass('acc-active')) {
            $(this).removeClass('acc-active');
            $(this).next().slideToggle('fast');
        } else {
            $(this).addClass('acc-active');
            $(".tus-accordion-toggle").not($(this)).removeClass('acc-active');
            $(this).next().slideToggle('fast');
            $(".tus-accordion-content").not($(this).next()).slideUp('fast');
        }
    });
}

function bindFormRecipe() {
    jQuery('#form-recipe').submit(function (event) {
        event.preventDefault();

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_recipe_ajax',
                async: true,
                form_data: jQuery('#form-recipe').serialize(),
            },
            success: function (response) {
                jQuery('#results').html(response);
            }
        });
    });
}

function bindFormOffer() {

    var $form_offer = jQuery('#form-offer');

    $form_offer.keydown(function(event) {
        var key = event.which;
        if (key === 13) {
            $('#form-offer').submit();
        }
    });

    $form_offer.submit(function (event) {
        event.preventDefault();

        var open = jQuery('.menu-aside li.open').data('category');
        var category = '';
        if(typeof open !== 'undefined') {
            category = '&crea_partner_offer_category=' + open;
        } else {
            open = 'all';
        }

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_offer_ajax',
                async: true,
                form_data: jQuery('#form-offer').serialize() + category,
            },
            success: function (response) {
                jQuery('#results').html(response);
                $('.js-match-height').matchHeight();
            }
        });
    });

    offerCategory();
}

function offerCategory() {
    $('.section-tus-partners-deals .js-menu-aside > li').click(function () {
        jQuery('#results').html('<div class="partner-spinner"><i class="fa fa-spinner fa-spin"></i></div>');
        var curr_url = window.location.href;
        if(curr_url.indexOf('page') !== -1) {
            window.history.pushState('', '', curr_url.substring(0, curr_url.indexOf('page')));
        }
        var curPage = 1;

        // if(/stran=.*/.test(url_text)) {
        //     curPage = 2;
        // } else {
        //     curPage = 1;
        // }

        // if(curPage != 1) {
        //     window.history.pushState(null, null, "?stran=" + curPage);
        // }

        var selected_cat = 'crea_partner_offer_category=' + $(this).data('category');

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_offer_ajax',
                async: true,
                form_data: selected_cat,
            },
            success: function (response) {
                jQuery('#results').html(response);
                console.log(response);
                jQuery('.js-match-height').matchHeight();
            }
        });
    });
}

jQuery('.section-tus-partners-deals').on('click', '.ajax-pagination a', function(e) {
    var form = jQuery('#form-offer');

    e.preventDefault();
    var index = $(this).data('index');

    var selected_cat = $('.js-menu-aside').find('li.open').data('category');
    console.log('sel', selected_cat);

    jQuery.ajax({
        type: "POST",
        url: ajax_object.ajaxurl,
        data: {
            action: 'creatim_offer_ajax',
            async: true,
            form_data: form.serialize() + '&page=' + index + '&crea_partner_offer_category=' + selected_cat
        },
        success: function (response) {
            jQuery('#results').html(response);
            $('.js-match-height').matchHeight();
        }
    });
});

function bindFormPost() {
    // jQuery('#submit-empty-post-form').click(
    //     function(event) {
    //         console.log('empty form post submit');
    //         $('#form-post')[0].reset();
    //         $('#form-post').submit();
    //     }
    // );

    jQuery('#post-order').change(function (event) {
        mainAjax({
            action: 'post_archive_ajax',
            formId: '#form-post',
            bindResultsToId: '#results'
        });
    });

    jQuery('#post-year').change(function (event) {
        mainAjax({
            action: 'post_archive_ajax',
            formId: '#form-post',
            bindResultsToId: '#results'
        });
    });
    var $form_post = jQuery('#form-post');

    $form_post.keydown(function(event) {
        var key = event.which;
        if (key === 13) {
            $('#form-post').submit();
        }
    });

    $form_post.submit(function (event) {
        event.preventDefault();
        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'post_archive_ajax',
                async: true,
                form_data: jQuery('#form-post').serialize()
            },
            success: function (response) {
                jQuery('#results').html(response);
                $('.js-match-height').matchHeight();
            }
        });
    });
}

function bindFormPostCategory() {

    jQuery('#submit-empty-post-category-form').click(function(event) {
            var $form_post_category = $('#form-post-category');
            $form_post_category[0].reset();
            $form_post_category.submit();
        }
    );

    jQuery('#order').change(function (event) {
        mainAjax({
            action: 'post_archive_ajax',
            formId: '#form-post-category',
            bindResultsToId: '#results'
        });
    });

    jQuery('#filter-post-date').change(function (event) {
        mainAjax({
            action: 'post_archive_ajax',
            formId: '#form-post-category',
            bindResultsToId: '#results'
        });
    });

    var $form_post_category = jQuery('#form-post-category');

    $form_post_category.keydown(function(event) {
        var key = event.which;
        if (key === 13) {
            $('#form-post-category').submit();
        }
    });

    $form_post_category.submit(function (event) {
        event.preventDefault();
        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'post_archive_ajax',
                async: true,
                form_data: jQuery('#form-post-category').serialize(),
            },
            success: function (response) {
                jQuery('#results').html(response);
                $('.js-match-height').matchHeight();
            }
        });
    });
}

function matchAjaxHeight() {
    if ($js_match_height.length) {
        //$('.js-match-height').matchHeight(false);
        $js_match_height.matchHeight({ byRow: false });
        //$('.js-match-height li').matchHeight({ byRow: false }); this breaks content-creatim_prize, because li is also in content and those lines are also matched.
    }
}

function matchAjaxHeightByRow() {
    if ($js_match_height_by_row.length) {
        $js_match_height_by_row.matchHeight({ byRow: true });
        $('.js-match-height-only-by-row li').matchHeight({ byRow: true });
    }
}

function match_height_coupon_description() {
    if($('.js-match-height-coupon-description').length) {
        $('.js-match-height-coupon-description').matchHeight();
    }
}

function matchSlickSlider() {
    var $js_slider_card = $('.js-slick-slider li .card');
    if ($js_slider_card.length) {
      setTimeout(function(){
        $js_slider_card.matchHeight({ byRow: true })
      }, 0);
    }

}

function bindFormPromotion() {

    var $form_promotion = jQuery('#form-promotion');

    $form_promotion.keydown(function(event) {
        var key = event.which;
        if (key === 13) {
            $('#form-promotion').submit();
        }
    });

    $form_promotion.submit(function (event) {

        event.preventDefault();

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_promotion_ajax',
                async: true,
                form_data: jQuery('#form-promotion').serialize()
            },
            success: function (response) {
                jQuery('#results').html(response);
            }
        });
    });

    jQuery('#sort').change(function (event) {
        mainAjax({
            action: 'creatim_promotion_ajax',
            formId: '#form-promotion',
            bindResultsToId: '#results'
        });
    });
}

function bindFormEvent() {
    var $form_event = $('#form-event');
    jQuery('#submit-empty-event-form').click(
        function(event) {
            $form_event[0].reset();
            $form_event.submit();
        }
    );

    jQuery('#form-event').keydown(function(event) {
        var key = event.which;
        if (key === 13) {
            $form_event.submit();
        }
    });

    $form_event.submit(function (event) {
        //console.log('form submitted');
        event.preventDefault();
        mainAjax({
            action: 'creatim_event_ajax',
            formId: '#form-event',
            bindResultsToId: '#results'
        });
    });

    jQuery('#filter-event').change(function (event) {
        mainAjax({
            action: 'creatim_event_ajax',
            formId: '#form-event',
            bindResultsToId: '#results'
        });
    });

    jQuery('#filter-date').change(function (event) {
        mainAjax({
            action: 'creatim_event_ajax',
            formId: '#form-event',
            bindResultsToId: '#results'
        });
    });
}

function mainAjax(args) {
    jQuery.ajax({
        type: "POST",
        url: ajax_object.ajaxurl,
        data: {
            action: args.action,
            async: true,
            form_data: jQuery(args.formId).serialize()
        },
        success: function (response) {
            jQuery(args.bindResultsToId).html(response);
            if ($js_match_height.length) {
                $js_match_height.matchHeight({ byRow: false });
                $('.js-match-height li').matchHeight({ byRow: false });
            }
            if ($js_match_height_by_row.length) {
                $js_match_height_by_row.matchHeight({ byRow: true });
                $('.js-match-height-only-by-row li').matchHeight({ byRow: true });
            }

        }
    });
}

function bindFormRecipeSearch() {

    var $form_recipe_search = jQuery('#form-recipe-search');
    $form_recipe_search.keydown(function(event) {
        var key = event.which;
        if (key === 13) {
            $form_recipe_search.submit();
        }
    });

    $form_recipe_search.submit(function (event) {
        event.preventDefault();

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_recipe_search_ajax',
                async: true,
                form_data: $form_recipe_search.serialize(),
            },
            success: function (response) {
                jQuery('#results').html(response);
            }
        });
    });
}

function prizeAjax(add) {

    var id;
    var action;
    if (add !== 'archive') {
        id = '';
        action = 'creatim_prize_ajax';
    } else {
        id = '-archive';
        action = 'creatim_prize_archive_ajax';
    }

    jQuery.ajax({
        type: "POST",
        url: ajax_object.ajaxurl,
        data: {
            action: action,
            async: true,
            form_data: jQuery('#form-prize' + id).serialize(),
        },
        success: function (response) {
            jQuery('#results' + id).html(response);
            matchAjaxHeight();
        }
    });
}

function bindFormPrizeArchive() {
    jQuery('#form-prize-archive').change(function (event) {
        prizeAjax('archive');
    });
}

function bindFormPrize() {
    jQuery('#form-prize').change(function (event) {
        prizeAjax();
    });
}

function bindAjaxPaginationFormRecipeSearch() {
    jQuery('.ajax-pagination a').click(function(e) {

        e.preventDefault();
        var index = $(this).data('index');

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_recipe_search_ajax',
                async: true,
                form_data: jQuery('#form-recipe-search').serialize() + '&page=' + index
            },
            success: function (response) {
                jQuery('#results').html(response);
                $('.js-match-height').matchHeight();
            }
        });
    });
}

function bindAjaxPaginationFormPost() {
    jQuery(document).ready(function () {

        jQuery('.ajax-pagination a').click(function (e) {

            var form = jQuery('#form-post');
            if (form.length === 0) {
                form = jQuery('#form-post-category');
            }

            e.preventDefault();
            var index = $(this).data('index');

            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                data: {
                    action: 'post_archive_ajax',
                    async: true,
                    form_data: form.serialize() + '&page=' + index
                },
                success: function (response) {
                    jQuery('#results').html(response);
                    $('.js-match-height').matchHeight();
                }
            });
        });
    });
}

function bindAjaxPaginationFormEvent() {
    jQuery(document).ready(function () {

        jQuery('.ajax-pagination a').click(function (e) {

            e.preventDefault();
            var index = $(this).data('index');

            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                data: {
                    action: 'creatim_event_ajax',
                    async: true,
                    form_data: jQuery('#form-event').serialize() + '&page=' + index
                },
                success: function (response) {
                    jQuery('#results').html(response);
                    $('.js-match-height').matchHeight();
                }
            });
        });
    });
}

function bindAjaxPaginationFormPrize() {
    jQuery(document).ready(function () {

        jQuery('.ajax-pagination a').click(function (e) {

            e.preventDefault();
            var index = $(this).data('index');

            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                data: {
                    action: 'creatim_prize_archive_ajax',
                    async: true,
                    form_data: jQuery('#form-prize-archive').serialize() + '&page=' + index
                },
                success: function (response) {
                    jQuery('#results-archive').html(response);
                    $('.js-match-height').matchHeight();
                }
            });
        });
    });
}

function bindAjaxPaginationFormPromotion() {
    jQuery(document).ready(function () {

        jQuery('.ajax-pagination a').click(function (e) {

            e.preventDefault();
            var index = $(this).data('index');

            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                data: {
                    action: 'creatim_promotion_ajax',
                    async: true,
                    form_data: jQuery('#form-promotion').serialize() + '&page=' + index
                },
                success: function (response) {
                    jQuery('#results').html(response);
                    $('.js-match-height').matchHeight();
                }
            });
        });
    });
}

function notPropagateFloorplan() {
    $('.shop-link').click(function(event){
        event.stopPropagation();
    });
}

function hideFloorplanPopup() {
    $('.page-template-template-floorplan').mouseup(function (e) {
        var floorplan_area = $('map');
        var shop_list = $('.js-collapsable-navigation-floorplan');

        if(!floorplan_area.is(e.target) &&
            floorplan_area.has(e.target).length === 0 &&
            !shop_list.is(e.target) &&
            shop_list.has(e.target).length === 0) {

            $('.js-floorplan-popup').css('display', 'none');
            $('.js-collapsable-navigation-floorplan li.open li.open').removeClass('open');
            $('.js-collapsable-navigation-floorplan li.open .submenu').css('display', 'none');
            $('.js-collapsable-navigation-floorplan li.open').removeClass('open');

            $("area").data('maphilight', { alwaysOn: false }).trigger('alwaysOn.maphilight');

        }
    });
}

// Cart

function showTabCart(n) {

    $('.section-cart').css({'display': 'none'});
    $('.steps .cart li').removeClass('active');

    $('.section-cart').eq(n).css({'display': 'block'});
    $('.steps .cart li').eq(n).addClass('active');
}

function cartQuestionmark(element) {
    if(element.closest('.product-details').find('.on-questiomark-hover').css('display') === 'none') {
        element.closest('.product-details').find('.on-questiomark-hover').css('display', 'block');
        // $('.on-questiomark-hover').css('display', 'block');
    } else {
        element.closest('.product-details').find('.on-questiomark-hover').css('display', 'none');
    }
}

// Career
function careerMobileNav() {

    $('#mobile-nav-career').on('change', function() {
        var data = $("#mobile-nav-career").val();
    });
}

function bindFormCareer() {

    var $form_career = jQuery('#form-career');
    if($form_career.length) {

        $form_career.keydown(function(event) {
            var key = event.which;
            if (key === 13) {
                $form_career.submit();
            }
        });

        //jQuery('#form-career select').change(function (event) {
        // mainAjax({
        //     action: 'post_archive_ajax',
        //     formId: '#form-post-category',
        //     bindResultsToId: '#results'
        // });
        //});

        $form_career.submit(function (event) {
            event.preventDefault();
            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                data: {
                    action: 'creatim_career_ajax',
                    async: true,
                    form_data: jQuery('#form-career').serialize()
                },
                success: function (response) {
                    jQuery('#results').html(response);
                }
            });
        });

        jQuery('#results').on('click', '.ajax-pagination a', function(e) {

            e.preventDefault();
            var index = $(this).data('index');

            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                async: true,
                data: {
                    action: 'creatim_career_ajax',
                    form_data: jQuery('#form-career').serialize() + '&click-page=' + index
                },
                success: function (response) {
                    jQuery('#results').html(response);
                    $('.js-match-height').matchHeight();
                }
            });
        });
    }
}

function geth2scroll() {
    $('.side-nav-title').each(function () {
        var id = $(this).closest('section').attr("id");
        if (typeof id !== 'undefined') {
            $('#ul-navigation-scroll').append(
                '<li class="nav-' + id + '">' +
                '<a href="#' + id +
                '"><span class="indicator js-indicator"></span>' +
                '<h5>' + $(this).text() + '</h5>' +
                '</a></li>'
            );
        }
    });
}

function sameHeightRecipe() {
    var cw = $('.card-recipe-category .background-image').width();
    $('.card-recipe-category .background-image').css('height', cw + 'px');
}

function enterSearchFullscreen() {
    $("#search-input-fullcreen").on("change paste keyup", function() {
        //console.log($('#search-input-fullcreen').val());
        var key = event.which;
        if (key === 13) {
            $('#fullscreen-search-form').submit();
        }
    });
}

function openModalCoupons() {
    $('.open-modal-coupon').click(function () {
        //console.log('coupon clicked');
        $('.show-coupon-modal').css('display', 'block');
    });
}

// function sameHeightRecipeCardSingle() {
//     var single_cw = $('.list-item-card-single-recipe').outerWidth();
//     $('.card-recipe .background-image').css('height', single_cw);
//     // console.log(single_cw);
// }


/**
 * Google Maps
 */
(function($) {

    /*
    *  new_map
    *
    *  This function will render a Google Map onto the selected jQuery element
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$el (jQuery element)
    *  @return	n/a
    */

    function new_map( $el ) {

        // var
        var $markers = $el.find('.marker');


        // vars
        var args = {
            zoom		: 16,
            center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP
        };


        // create map
        var map = new google.maps.Map( $el[0], args);


        // add a markers reference
        map.markers = [];


        // add markers
        $markers.each(function(){

            add_marker( $(this), map );

        });


        // center map
        center_map( map );


        // return
        return map;

    }

    /*
    *  add_marker
    *
    *  This function will add a marker to the selected Google Map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	$marker (jQuery element)
    *  @param	map (Google Map object)
    *  @return	n/a
    */

    function add_marker( $marker, map ) {

        // var
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

        // custom icon
        var icon = {
            url: url.templatedir + '/dist/images/icon-location-gmap.svg',
            scaledSize: new google.maps.Size(30, 30), // scaled size
            //origin: new google.maps.Point(0,0), // origin
            //anchor: new google.maps.Point(0, 0) // anchor
        };

        // create marker
        var marker = new google.maps.Marker({
            position	: latlng,
            map			: map,
            icon		: icon,
            animation	: google.maps.Animation.DROP
        });

        // add to array
        map.markers.push( marker );

        // if marker contains HTML, add it to an infoWindow
        if( $marker.html() )
        {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content		: $marker.html()
            });

            // show info window when marker is clicked
            google.maps.event.addEventListener(marker, 'click', function() {

                infowindow.open( map, marker );

            });
        }

    }

    /*
    *  center_map
    *
    *  This function will center the map, showing all markers attached to this map
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	4.3.0
    *
    *  @param	map (Google Map object)
    *  @return	n/a
    */

    function center_map( map ) {

        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each( map.markers, function( i, marker ){

            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

            bounds.extend( latlng );

        });

        // only 1 marker?
        if( map.markers.length == 1 )
        {
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 13 );
        }
        else
        {
            // fit to bounds
            map.fitBounds( bounds );
        }

    }

    /*
    *  document ready
    *
    *  This function will render each map when the document is ready (page has loaded)
    *
    *  @type	function
    *  @date	8/11/2013
    *  @since	5.0.0
    *
    *  @param	n/a
    *  @return	n/a
    */
// global var
    var map = null;

    $(document).ready(function(){

        $('.location-map').each(function(){

            // create map
            map = new_map( $(this) );

        });

    });

})(jQuery);

jQuery(document).ready(function(){

  jQuery(window).on('load', function() {
    if (window.location.hash) {
      var offset = 98;
      var hash = window.location.hash;
      if ($(hash).length) {
        $('html, body').animate({
          scrollTop: $(hash).offset().top - offset
        }, 1000);
      }
    }
  });

    $(document).on('click', '.nf-field input', function () {
        // if($('.nf-field input[checkbox]').length == 0){
        // $(this).prop('checked', 'true');
        // $.each(this.attributes,function(i,a){
        //     console.log(i,a.name,a.value);
        // });
        console.log($(this).prop('checked'));

        // }
    });

    // question mark on cart item

    if($(window).width() <= 480) {
        $('.questionmark').click(function (e) {
            e.preventDefault();
            cartQuestionmark($(this));
        });
    } else {
        $('.questionmark').hover(function (e) {
            cartQuestionmark($(this));
        });
    }


    // datepicker pozabljen PIN
    if($('.birth_pin').length) {
        jQuery('.birth_pin').datepicker();
    }

    // format inputa za število računa pri registraciji
    if($('.mask_stevilka_racuna').length) {
        $('.mask_stevilka_racuna').mask('0000-0000-0000000');
    }

    // slika racuna na registraciji
    $('.js-fullscreen-registracija-toggle').click(function(e) {
        e.preventDefault();

        if (!$(this).hasClass('open')) {
            $('.js-fullscreen-registracija').addClass('open');
            $('.js-fullscreen-registracija input[type="text"]').focus();
            $('.js-fullscreen-registracija-toggle').addClass('open');
        }
    });

    $('.js-fullscreen-registracija .js-btn-close').click(function(e) {
        e.preventDefault();

        $('.js-fullscreen-registracija').removeClass('open');
        $('.js-fullscreen-registracija-toggle').removeClass('open');
    });

    if($.validator) {
        $.validator.addMethod('postCodeFromList', function (value, element) {
            return this.optional(element) || (value in postCity);

        }, 'Prosimo, vnesite veljavno poštno številko');

        $.validator.addMethod(
            "regexTel",
            function(value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            },
            "Vnesite veljavno telefonsko številko"
        );

        $('#prize-contest').validate({
            rules: {
                tus_name: {
                    required: true,
                },
                tus_surname: {
                    required: true,
                },
                tus_street: {
                    required: true,
                },
                tus_city: {
                    required: true,
                },
                tus_post: {
                    required: true,
                    minlength: 4,
                    postCodeFromList: true
                },
                tus_cardNumber: {
                    required: true,
                    minlength: 13,
                    maxlength: 13
                },
                tus_receiptNumber: {
                    required: true,
                },
                tus_email: {
                    required: true,
                },
                tus_conditions: {
                    required: true,
                },
                tus_phoneNumber: {
                    regexTel: "[0-9]+",
                    minlength: 9,
                    maxlength: 9
                },
            },
            messages: {
                tus_name: "Prosimo, vnesite ime",
                tus_surname: {
                    required: "Prosimo, vnesite priimek"
                },
                tus_street: {
                    required: "Prosimo, vnesite naslov"
                },
                tus_post: {
                    required: "Prosimo, vnesite poštno številko",
                    minlength: "Prosimo, vnesite štirimestno število"
                },
                tus_city: {
                    required: "Kraj je vnešen na podlagi veljavne poštne številke"
                },
                tus_email: {
                    required: "Prosimo, vnesite e-poštni naslov"
                },
                tus_cardNumber: {
                    required: "Prosimo, vnesite številko kartice",
                    minlength: "Vnesite 13 mestno številko Tuš klub kartice",
                    maxlength: "Vnesite 13 mestno številko Tuš klub kartice"
                },
                tus_receiptNumber: {
                    required: "Prosimo, vnesite številko računa",
                },
                tus_conditions: {
                    required: "Potrebno se je strinjati s pogoji poslovanja",
                },
                tus_conditions_extra: {
                    required: "Potrebno se je strinjati s pogoji poslovanja",
                },
                tus_phoneNumber: {
                    minlength: "Vnesite veljavno telefonsko številko",
                    maxlength: "Vnesite veljavno telefonsko številko",
                },
            },
            errorPlacement: function (error, element) {
                if (element.attr("name") === "tus_conditions") {
                    error.insertAfter(".agree-terms-label");
                } else if(element.attr("name") === "tus_answer"){
                    error.insertAfter(".list-questions");
                } else if (element.attr("name") === "tus_conditions_extra"){
                    error.insertAfter(".agree-terms-label-extra");
                }
                else {
                    error.insertAfter(element);
                }
            },
            onfocusout: function (element) {
                this.element(element);
            }
        });





        $('#pozabljen_pin').validate({
            rules: {
                tus_cardNo: {
                    required: true,
                    minlength: 13,
                    maxlength: 13,
                    digits: true
                },
                tus_name: {
                    required: true,
                },
                tus_surname: {
                    required: true,
                },
                tus_birth: {
                    required: true,
                },
                tus_phone: {
                    required: true,
                    minlength: 9
                }
            },
            messages: {
                tus_cardNo: {
                    required: "Prosimo, vnesite številko kartice",
                    minlength: "Številka obstoječe kartice mora biti dolga 13 znakov",
                    maxlength: "Številka obstoječe kartice mora biti dolga 13 znakov",
                    digits: "Številka obstoječe kartice lahko vsebuje samo številke"
                },
                tus_name: {
                    required: "Prosimo, vnesite ime"
                },
                tus_surname: {
                    required: "Prosimo, vnesite priimek"
                },
                tus_birth: {
                    required: "Prosimo, vnesite datum rojstva"
                },
                tus_phone: {
                    required: "Prosimo, vnesite telefonsko številko",
                    minlength: "Prosimo, vnesite najmanj devetmestno število"
                },
            },
            errorPlacement: function (error, element) {
                if (element.attr("name") === "tus_conditions") {
                    error.insertAfter(".agree-terms-label");
                }
                else {
                    error.insertAfter(element);
                }
            },
            onfocusout: function (element) {
                this.element(element);
            }
        });


        /**
         Validation for e-obveščanje
         */

        $('#tusNewsletter').validate({
            rules: {
                email: {
                    required: true,
                    email: true
                },
                consent: {
                    required: true,
                },
            },
            messages: {
                email: {
                    required: "Prosimo, vnesite e-naslov",
                    email: 'E-naslov ni veljaven'
                },
                consent: {
                    required: "Potrditev je obvezna"
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("name") === "consent") {
                    error.insertAfter(".error-after-label");
                }
                else {
                    error.insertAfter(element);
                }
            },
        });
    }

    /**
     * Dynamic content navigation
     * Uses span tag to build dynamic navigation on one pager site
     * <span class="content-navigation" data-id="o-pivnici" data-title="O pivnici"></span>
     */
        // if(jQuery('.tabs.lite').length) {
        //     jQuery('.content-navigation').each(function () {
        //         var list = '<li>' + '<a href="#" data-id="' + jQuery(this).data('id') + '">' + jQuery(this).data('title') + "</a>" + "</li>";
        //         jQuery('.tabs').append(list);
        //     });
        //
        //     jQuery('.tabs a').click(function (event) {
        //         event.preventDefault();
        //         var attribute = jQuery(this).attr('data-id');
        //         jQuery('html, body').animate({
        //             scrollTop: jQuery('.content-navigation[data-id="' + attribute + '"]').offset().top - jQuery('.navigation-primary').height() - 40
        //         }, 1000);
        //     });
        // }





        // gets quantity on plus and minus woocommerce cart
    var $quantity = $('.quantity');
    $quantity.on('click', '.minus', function (e) {
        e.preventDefault();
        var $inputQty = $(this).parent().find('input.qty');
        var val = parseInt($inputQty.val());
        var step = $inputQty.attr('step');
        step = 'undefined' !== typeof(step) ? parseInt(step) : 1;
        if (val > 0) {
            $inputQty.val(val - step).change();
        }
    });
    $quantity.on('click', '.plus', function (e) {
        e.preventDefault();
        var $inputQty = $(this).parent().find('input.qty');
        var val = parseInt($inputQty.val());
        var step = $inputQty.attr('step');
        step = 'undefined' !== typeof(step) ? parseInt(step) : 1;
        $inputQty.val(val + step).change();
    });

    // scrolling, side navigation
    // function cloned from custom.js, so it works for rendered elements
    $(document).not('.vce-classic-tabs-tab-title').on('click','a:not([href="#"], [href="#0"])', function(e) {
            var offset = 98;

            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = $(this.hash);
                if (target.length) {
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                    if (target.length) {
                        event.preventDefault();

                        $('html, body').animate({
                          scrollTop: target.offset().top - offset
                        }, 1000);
                    }
                }
            }
    });



    $('body').on('click', 'a.btn[href^="#"]:not([href="#"], [href="#0"])', function(e){
      var thisHref = $(this).attr('href');

      var offset = $('body').find('header.header').outerHeight();

      if($('body').find(thisHref).length) {
        var target = $('body').find(thisHref);
        $('html, body').animate({
          scrollTop: target.offset().top - offset
        }, 500);
      }


    });

    // scrolling for area
    // $(document).on('click','area', function(e) {
    //     var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
    //     var elID = $(this).attr('id');
    //     var elLink = $(this).parent().data('link');
    //     var parentOffset = $('.floorplan-wrapper').offset();
    //
    //     var relX = e.pageX - parentOffset.left + 20;
    //     var relY = e.pageY - parentOffset.top - ($('.js-floorplan-popup').height() / 2 + 10);
    //
    //     $('.js-collapsable-navigation-floorplan[data-link="' + elLink + '"] .submenu li[data-id="' + elID + '"]').trigger('click');
    //
    //     //flip popup
    //     if (e.pageX - parentOffset.left > 360) {
    //         relX = e.pageX - parentOffset.left - 360;
    //         $('.js-floorplan-popup').addClass('flip');
    //     } else {
    //         $('.js-floorplan-popup').removeClass('flip');
    //     }
    //
    //     //show popup
    //     $('.js-floorplan-popup').css({top: relY, left: relX}).show();
    //
    //     if(!isMobile) {
    //
    //         var offset = 198;
    //
    //         if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
    //             var target = $(this.hash);
    //             target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    //
    //             if (target.length) {
    //                 event.preventDefault();
    //
    //                 $('html, body').animate({
    //                     scrollTop: target.offset().top - offset
    //                 }, 1000);
    //             }
    //         }
    //     }
    // });

    $(document).on('click', '.shopping-list.menu-shopping-list', function (e) {
        e.preventDefault();

        var logged_in;
        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'tk_user_logged_in',
                async: true
            },
            success: function (response) {
                logged_in = $.parseJSON(response).loggedIn;

                if (!logged_in) {
                    $('.js-fullscreen-shopping-list-change').addClass('open');
                } else {
                    document.location.href = $('.shopping-list.menu-shopping-list').attr('href');
                }
            }
        });
    });

    // $('.js-btn-submit-shopping-list-change').on('click', function () {
    //     var selected_list = $('#shopping-list-selected').val();
    //     console.log($('.shopping-list.menu-shopping-list').attr('href'));
    //     document.location.href = $('.shopping-list.menu-shopping-list').attr('href') + '&listek_id=' + selected_list;
    // });

    // if($('.cookie-column').length) {
    //     $('.cookie-column input.custom-input-toggle').each(function () {
    //         console.log('cookie column');
    //         console.log($('.cookie-column input.custom-input-toggle').attr('checked'));
    //
    //         if ($('.cookie-column input.custom-input-toggle').attr('checked') != null) {
    //             $('.cookie-column input.custom-input-toggle').next('.cookie-allow-text').text('Dovolim');
    //
    //         } else {
    //             $('.cookie-column input.custom-input-toggle').next('.cookie-allow-text').text('Ne dovolim');
    //         }
    //     });
    //
    // }


    allowCookies();

    vcAccordion();
    geth2scroll();
    matchAjaxHeightByRow();
    matchSlickSlider();
    match_height_coupon_description();
    enterSearchFullscreen();

// Coupons
    openModalCoupons();

//Offers
    bindFormOffer();

//Posts
    bindFormPost();
    bindFormPostCategory();

//Prizes
    bindFormPrize();
    bindFormPrizeArchive();

//Recipes
    bindFormRecipe();
    bindFormRecipeSearch();
    sameHeightRecipe();

//Events
    bindFormEvent();

// Promotions
    bindFormPromotion();

// Career
    careerMobileNav();
    bindFormCareer();

//requestEventsByCurrentCenterId
    requestNewEvents(Cookies.get('tus_center_location'), jQuery('#results-tus-events'));

    $(document).on('click','.js-fullscreen-location-change-toggle', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('open')) {
            $('.js-fullscreen-location-change').addClass('open');
            $('.js-fullscreen-location-change-toggle').addClass('open');
        }
    });

    $(document).on('click','.js-fullscreen-show-poslovalnice-toggle', function(e) {
        e.preventDefault();

        if (!$(this).hasClass('open')) {
            $('.js-fullscreen-show-poslovalnice-toggle').addClass('open');
            $('.js-fullscreen-show-poslovalnice').addClass('open');
        }
    });

    $('.js-fullscreen-show-poslovalnice .js-btn-close').click(function(e) {
        e.preventDefault();

        $('.js-fullscreen-show-poslovalnice').removeClass('open');
        $('.js-fullscreen-show-poslovalnice-toggle').removeClass('open');
    });

    $('.js-fullscreen-login-notification .js-btn-close').click(function(e) {
        e.preventDefault();
        $('.js-fullscreen-login-notification').removeClass('open');
    });

  $(document).on('click','.js-fullscreen-newsletter-toggle', function(e) {
    e.preventDefault();

    if (!$(this).hasClass('open')) {
      $('.js-fullscreen-newsletter').addClass('open');
      $('.js-fullscreen-newsletter-toggle').addClass('open');
    }
  });

    notPropagateFloorplan();
    hideFloorplanPopup();

    /**
     * Prevent dots click on pagination
     */
    $('a.dots').click(function(e){
        e.preventDefault();
    });

    bindFrontPageProducts();

    checkRecaptcha();

    redirect_gostinstvo();

    activeNavGostinstvo();

    $('.goBack').click(function () {
        goBack();
    });

// matchpdfImages();

    /**
     * Close section-tus-coupons section and write to cookie
     */
    jQuery('.section-tus-coupons .js-close').click(function(e) {
        Cookies.set('tus-close-section-tus-coupons', 'true', {
            expires: 30,
            path: '/',
            secure: true
        });
    });

    var tusCloseCouponsCookie = Cookies.get('tus-close-section-tus-coupons');
    if(tusCloseCouponsCookie === 'true') {
        var elTarget = jQuery('.section-tus-coupons');
        elTarget.slideUp(300, function() {
            if (elTarget != 'slide') {
                $(this).remove();
            }
        });
    }
    /**--------------------------------------------*/

    openReal3dFlipBook();

    if($('.article-career').length > 0 || $('.article-career-field').length > 0) {
        console.log('in if carre called');

        countCareerField();
    }

    /*
     * copied code from web/app/plugins/woocommerce-products-filter/js/front.js and replaced .life for .on
     */
    jQuery('.woof_open_hidden_li_btn').on('click', function () {
        var state = jQuery(this).data('state');
        var type = jQuery(this).data('type');

        if (state == 'closed') {
            jQuery(this).parents('.woof_list').find('.woof_hidden_term').addClass('woof_hidden_term2');
            jQuery(this).parents('.woof_list').find('.woof_hidden_term').removeClass('woof_hidden_term');
            if (type == 'image') {
                jQuery(this).find('img').attr('src', jQuery(this).data('opened'));
            } else {
                jQuery(this).html(jQuery(this).data('opened'));
            }

            jQuery(this).data('state', 'opened');
        } else {
            jQuery(this).parents('.woof_list').find('.woof_hidden_term2').addClass('woof_hidden_term');
            jQuery(this).parents('.woof_list').find('.woof_hidden_term2').removeClass('woof_hidden_term2');

            if (type == 'image') {
                jQuery(this).find('img').attr('src', jQuery(this).data('closed'));
            } else {
                jQuery(this).text(jQuery(this).data('closed'));
            }

            jQuery(this).data('state', 'closed');
        }


        return false;
    });

});

/*
 * Geolocation Haversine formula for zabava/centri
 */
Geolocation = {
    rad: function (x) {
        return x * Math.PI / 180;
    },

    // Distance in kilometers between two points using the Haversine algo.
    haversine: function (p1, p2) {
        var R = 6371;
        var dLat = this.rad(p2.lat - p1.latitude);
        var dLong = this.rad(p2.lng - p1.longitude);

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.rad(p1.latitude)) * Math.cos(this.rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;

        return Math.round(d);
    },

    // Distance between me and the passed position.
    distance_from: function (position, currentLocation) {
        return Geolocation.haversine(position.coords, currentLocation);
    }
};

function getLocation() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(calculateDistance, errorDistance, {
            maximumAge:Infinity,
            timeout:10000,
            enableHighAccuracy:false
        });
    } else {
        console.log("Geolocation is not supported by your browser.");
    }
}

function calculateDistance(position) {
    var shortestDistance = {
        distance: -1,
        object: {}
    };
    jQuery('li.tus-center-location').each(function (index) {
        //console.log(jQuery(this).attr('data-lat'));
        //console.log(jQuery(this).attr('data-lng'));
        var distance = Geolocation.distance_from(
            position,
            { lat: jQuery(this).attr('data-lat'), lng: jQuery(this).attr('data-lng') }
        );
        if (distance < shortestDistance.distance || shortestDistance.distance === -1) {
            shortestDistance.distance = distance;
            shortestDistance.object = jQuery(this);

            //console.log(shortestDistance);
        }
    });

    // if(shortestDistance.object.data('permalink') !== window.location.href ) {
    //     window.location.replace(shortestDistance.object.data('permalink') + '/gostinstvo');
    // }
}

function errorDistance(error) {
    switch(error.code) {
        case error.PERMISSION_DENIED:
            console.log("Location redirect error: User denied the request for Geolocation.");
            break;
        case error.POSITION_UNAVAILABLE:
            console.log("Location redirect error: Location information is unavailable.");
            break;
        case error.TIMEOUT:
            console.log("Location redirect error: The request to get user location timed out.");
            break;
        case error.UNKNOWN_ERROR:
            console.log("Location redirect error: An unknown error occurred.");
            break;
    }
}

/**
 * Update location cookie on location change (.form-fullscreen-location-change)
 */
jQuery('.js-btn-submit-location-change').click(function(e) {

    e.preventDefault();

    var active = jQuery('.js-change-location .active');

    Cookies.set('tus_center_location', active.data('id'), { path: '/', secure: true });

    //redirect to selected center if on zabava

    if($('.tus-zabava').length > 0) {
        window.location.href = active.data('permalink');
    } else {
        // ajax call for events
        console.log(Cookies.get('tus_center_location'));
        requestNewEvents(active.data('id'), $('.fp-events'));
    }

    //requestNewEvents(active.data('id'));
});

/**
 * Ajax request new events on location change, if #results-tus-events exists on current page
 */
function requestNewEvents(currentCenterId, elementResults) {

    if(typeof (currentCenterId) === 'undefined') {
        currentCenterId = Cookies.get('tus_center_location');
    }
    var data = 'current_center_id=' + currentCenterId;

    // if (typeof(currentCenterId) === 'undefined') {
    //     data = '';
    // }

    if(elementResults.length) {

        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'creatim_event_front_page_ajax',
                async: true,
                form_data: data,
            },
            success: function (response) {
                elementResults.html(response);
            }
        });

    }
}

//# sourceMappingURL=tus-custom.js.map



/**
 * action: products_front_page_ajax
 */
function bindFrontPageProducts() {
    jQuery('select.js-custom-select-menu-aside option').on('change', function(){
        var taxonomy = jQuery(this).data('taxonomy');
        //one is loaded on document ready
        if(jQuery(this).value != 1) {
            //check if ul is already populated
            if (jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"] ul').has('li').length == 0 ) {
                var postsPerPage = jQuery(this).data('postsperpage');
                var postsPerPage = jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"]').data('postsperpage');
                var portal = jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"]').data('portal');
                ajaxFrontPageProducts(taxonomy, portal, postsPerPage);
            }
        }
    });

    jQuery('.js-products-ajax .js-menu-aside li').on('click', function(){
        var taxonomy = jQuery(this).data('taxonomy');
        //one is loaded on document ready
        if(jQuery(this).data('id') != 1) {
            //check if ul is already populated
            if (jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"] ul').has('li').length == 0 ) {
                var postsPerPage = jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"]').data('postsperpage');
                var portal = jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"]').data('portal');
                ajaxFrontPageProducts(taxonomy, portal, postsPerPage);
            }
        }
    });
}

function ajaxFrontPageProducts(taxonomy, portal, postsPerPage, sortby, sort) {

    portal = typeof portal !== 'undefined' ? portal : false;
    portal = '&portal=' + portal;
    postsPerPage = typeof postsPerPage !== 'undefined' ? postsPerPage : 6;
    postsPerPage = '&postsPerPage=' + postsPerPage;
    sort = typeof sort !== 'undefined' ? '&sort=' + sort : '' ;
    sortby = typeof sortby !== 'undefined' ? '&sortby=' + sortby : '' ;

    //check if term is also defined for taxonomy, taxonomy and term must be separated by '|'
    var formData = '';
    if (taxonomy.indexOf('|') !== -1) {
        var res = taxonomy.split('|');
        formData = 'taxonomy=' + res[0] + '&term=' + res[1];
    } else {
        formData = 'taxonomy=' + taxonomy;
    }

    jQuery.ajax({
        type: "POST",
        url: ajax_object.ajaxurl,
        data: {
            action: 'products_front_page_ajax',
            async: true,
            form_data: formData + portal + postsPerPage + sortby + sort
        },
        success: function (response) {
            jQuery(this).data('taxonomy');
            jQuery('.js-menu-aside-content[data-taxonomy="'+taxonomy+'"] ul').html(response);
            applyListAddListeners();
            applyM10ActivateListener();
        }
    });
}

//mojih10 tabs sort
// jQuery('select.js-custom-select').on('change', function(){
//     var sort = jQuery(this).find('option:selected').data('sort');
//     var sortby = jQuery(this).find('option:selected').data('sortby');
//     var taxonomy = '';
//     var postsPerPage = '';
//     var portal = '';
//
//     jQuery('.js-tab-content.open').find('.js-menu-aside-content.open').each(function(){
//         taxonomy = jQuery(this).data('taxonomy');
//         postsPerPage = jQuery(this).data('postsperpage');
//         portal = jQuery(this).data('portal');
//     });
//
//     if(typeof taxonomy !== 'undefined') {
//         // jQuery(this).val('0'); //clear selection
//         ajaxFrontPageProducts(taxonomy, portal, postsPerPage, sortby, sort);
//     }
// });

jQuery('body').find('.js-custom-select-url').on('select2:select', function(e){
    console.log(e.params.data.id);
    if(e.params.data.id != '') {
        location.href = e.params.data.id;
    }
    return;

});
/**-----------------------------------------*/

/**
 * Gostinstvo redirect
 */
function redirect_gostinstvo() {
    jQuery('.list-webpages .gostinstvo').click(function(e){
        e.preventDefault();
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(getClosestGostinstvo, onNoGeolocation, {
                maximumAge:Infinity,
                timeout:10000,
                enableHighAccuracy:false
            });
        } else {
            console.log("Geolocation is not supported by your browser.");
        }
    });
}

/**
 * Gostinstvo nav active
 */

function activeNavGostinstvo() {
    var url = window.location.href;
    var url_arr = url.split('/');
    var $list_webpages_gostinstvo = $('.list-webpages .gostinstvo');

    if (url_arr[url_arr.length - 2] === 'gostinstvo') {
        $('.list-webpages > li').removeClass('active');
        $list_webpages_gostinstvo.addClass('active');
    } else {
        if ($list_webpages_gostinstvo.hasClass('active')) {
            $list_webpages_gostinstvo.removeClass('active');
        }
    }
}


function onNoGeolocation() {
    getClosestGostinstvo(false);
    errorDistance();
}

function getClosestGostinstvo(location) {
    var lat = false;
    var lng = false;

    if(location !== false) {
        lat = location.coords.latitude;
        lng = location.coords.longitude;
    }

    jQuery.ajax({
        type: "POST",
        url: ajax_object.ajaxurl,
        data: {
            action: 'tus_closest_gostinstvo_ajax',
            async: true,
            data: 'lat='+lat+'&lng='+lng
        },
        success: function (response) {
            response = jQuery.parseJSON(response);
            if(response.permalink !== window.location.href ) {
                window.location.replace(response.permalink);
            }
        }
    });
}
/**-----------------------------------------*/

/** career mobile menu */

if (jQuery(".career-mobile-menu").length) {
    $('.career-mobile-menu').on('change', function() {
        window.location.href = $(this).find(":selected").val();
    });
}

/** match height of pdf images* */
// function matchpdfImages() {
//     console.log('matchPdfImages');
//     if ($('.section-catalogue-and-magazines .card-catalogue figure').length) {
//         console.log('matchPdfImages in if');
//         $('.section-catalogue-and-magazines .card-catalogue figure').matchHeight({ byRow: true });
//     }
// }


/**
 * Recaptcha
 */
function checkRecaptcha() {
    jQuery('form').submit(function(event) {
        var gRecaptcha = jQuery(this).find('#tus-g-recaptcha');
        if(gRecaptcha.length) {
            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                async: false,
                data: {
                    action: 'verify_recaptcha_ajax',
                    form_data: jQuery(this).serialize()
                },
                success: function (response) {
                    console.log('this in qorking recaptcha', $(this));
                    var json_response = jQuery.parseJSON(response);
                    if (json_response.verified === 'true') {
                        return true;
                    }
                    if (json_response.verified === 'false') {
                        if(jQuery('.notification-recaptcha').length === 0) {
                            jQuery('#tus-g-recaptcha').after('<div class="notification warning notification-recaptcha"><h3>' + json_response.message + '</h3></div>');
                        }
                        event.preventDefault();
                    }
                }
            });
        } else {
            return true;
        }
    });
}
/**-------------------------------------------*/

/**
 * Ninjaforms datepicker translate

 */
jQuery(document).ready(function () {
    if($('.nf-form-cont').length) {
        var NFDatepickerTranslate = Marionette.Object.extend({
            initialize: function () {
                /*
                 * Listen to our date pickers as they are created on the page.
                 */
                this.listenTo(Backbone.Radio.channel('pikaday'), 'init', this.modifyDatepicker);
            },

            modifyDatepicker: function (dateObject, fieldModel) {
                dateObject.pikaday._o.i18n = {
                    previousMonth: 'Prejšnji mesec',
                    nextMonth: 'Naslednji mesec',
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
                    weekdays: ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'],
                    weekdaysShort: ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'],
                };
            }
        });

        new NFDatepickerTranslate();
    }
});
